import { createContext } from 'react';

/**
 * The opt-in right rail.
 *
 * The BRIEF asks for a 320–360px column "not built now, but the shell must accommodate it
 * without a rewrite". This is that accommodation: the shell's content row is already two
 * columns, and a page opts in by rendering `<RightRail>` anywhere in its tree.
 *
 * Occupancy is ref-counted rather than derived from a prop, because the page that fills
 * the rail is nested arbitrarily deep inside `<Outlet/>` and the shell has no way to ask.
 */
export type RightRailContextValue = {
  /** The <aside> pages portal into. `null` until the shell's first commit. */
  host: HTMLElement | null;
  setOccupied: (occupied: boolean) => void;
};

export const RightRailContext = createContext<RightRailContextValue | undefined>(undefined);
